import { pbrAxios,baseUrl } from '../../common/js/pbrAxios'
import {Message} from 'view-design'
import i18n from '../../components/I18n'

/**
 * 导出文件类型-枚举
 * @type {{excel: string, word: string}}
 */
export const contentType = {
  excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  word:'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
}

/**
 * 下载文件
 * @param url
 * @param parameter
 * @returns {*}
 */
export function downFile(url, parameter, requestConfig = {}){
  return pbrAxios({
    url: url,
    params: parameter,
    method:'GET',
    responseType: 'blob',
    ...requestConfig
  })
}


/**
 * 下载文件
 * @param url
 * @param parameter
 * @returns {*}
 */
export function downFilePost(url, parameter, requestConfig = {}){
  return pbrAxios({
    url: url,
    data: parameter,
    method:'post' ,
    responseType: 'blob',
    ...requestConfig
  })
}

function notifyExportFailure () {
  Message.destroy()
  Message.warning(i18n.t('message.warning.prompt.exportFailure'))
}

/**
 * 按文件类型导出文件
 * @param url： 文件接口地址
 * @param params：请求参数
 * @param fileName： 要保持文件的名称
 * @param contentType： 请求类型
 * @param suffix： 文件后缀名
 */
export function  exportFilePost(url, params, fileName, contentType, suffix, callback, requestConfig = {}){
  Message.loading({
    content: i18n.t('message.fileGenerating'),
    duration: 0
  });
  downFilePost(url, params, requestConfig).then((data) => {
    if (!data || (typeof data === 'object' && !(data instanceof Blob))) {
      notifyExportFailure()
      return
    }
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(new Blob([data], { type: contentType }), fileName + suffix )
    } else {
      let url = window.URL.createObjectURL(new Blob([data], { type: contentType }))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName + suffix)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) //下载完成移除元素
      window.URL.revokeObjectURL(url) //释放掉blob对象
    }
    Message.destroy()
    callback && callback()
  }).catch(() => {
    notifyExportFailure()
  })
}

/**
 * 按文件类型导出文件
 * @param url： 文件接口地址
 * @param params：请求参数
 * @param fileName： 要保持文件的名称
 * @param contentType： 请求类型
 * @param suffix： 文件后缀名
 */
export function  exportFile(url, params, fileName, contentType, suffix, callback, requestConfig = {}){
  Message.loading({
    content: i18n.t('message.fileGenerating'),
    duration: 0
  });
  downFile(url, params, requestConfig).then((data) => {
    if (!data || (typeof data === 'object' && !(data instanceof Blob))) {
      notifyExportFailure()
      return
    }
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(new Blob([data], { type: contentType }), fileName + suffix )
    } else {
      let url = window.URL.createObjectURL(new Blob([data], { type: contentType }))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName + suffix)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) //下载完成移除元素
      window.URL.revokeObjectURL(url) //释放掉blob对象
    }
    Message.destroy()
    callback && callback()
  }).catch(() => {
    notifyExportFailure()
  })
}

/**
 * 通过URL访问的公共接口
 *
 * @param {Object}params - 请求参数
 * @returns {AxiosPromise<any>}
 */
const requestByUrl = (url, params, method = 'post') => {
  return pbrAxios({
    url,
    [method.toUpperCase() === 'GET' ? 'params' : 'data']: params,
    method
  })
}

/**
 *地区一级|二级|三级获取接口
 * @param {Object}params - 请求参数
 *    @param {String}params.from:en:英文 cn：中文  其他：中文
 *    @param {String}params.pid:父级编号  如果是获取国家则可为空或0
 *    @param {Number}params.level: 1：获取国家列表  2：获取国家下面二级数据   3：获取三级数据，类似中国的市
 *    @param {Number}params.type: all|a：根据 from、pid、level获取所有的数据    match|m：根据from、pid、level、name匹配相应级别模糊匹配name的地区数据
 *    @param {Number}params.name: 输入的部分地区名称
 * @returns {AxiosPromise<any>}
 */
const fetchRegionList = params => {
  return pbrAxios.post('/front/region/list', params)
}

/**
 * 前端——项目|分析|资讯获取检索条件
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.from:en:英文  cn：中文  其他：中文
 *    @param {String}params.index:所需条件页面位置 sy:首页  xm：项目  zx:资讯   fx：分析  默认是项目
 *    @param {String}params.module: 类型，当页面是资讯时才有用  xm：项目  fx：风险  sj：商机   fxsj：风险事件
 * @returns {AxiosPromise<any>}
 */
const fetchConditionInfo = params => {
  return pbrAxios.post('/front/condition/info', params)
}

/**
 * 前端——用户收藏（添加，取消）
 *
 * @param {Object}params - 请求参数

 *    @param {Number}params.id: 当前实例id
 *    @param {Number}params.type:收藏类型1：商机 2：企业 3：项目 4：风险 5：资讯
 *    @param {Number}params.userid: 当前用户
 *    @param {String}params.from: //取消
 * @returns {AxiosPromise<any>}
 */
const editFavorite = (type, params) => {
  return pbrAxios.post(`/front/userFav/${type}`, params)
}

/**
 * 重点资讯推荐
 * @param params
 *  @param {Number}params.pageNo: 当前页
 *  @param {Number}params.pageSize: 每页多少
 *  @param {String}params.lang: 语言
 *  @param {Number}params.userId: 语言
 * @returns {AxiosPromise<any>}
 */
const fetchSeriousArticle = (params) => pbrAxios.get('/front/home/getPullArticle', {params})

/**
 * 搜索联想关键词
 * @param params
 *  @param {String}params.keyword: 输入词（字）
 * @returns {AxiosPromise<any>}
 */
const associationWords = (params) => pbrAxios.get('/front/project/associationWords', {params})

/**
 * 验证当前登录用户，并注入cookie
 * @param params
 *  @param {BigInt} params.uid
 *  @param {String} params.token
 * @returns {AxiosPromise<any>}
 */
const checkUserId = (params) => pbrAxios.post('/api/front/checkUserId', params)


export default {
  requestByUrl,
  fetchRegionList,
  fetchConditionInfo,
  editFavorite,
  fetchSeriousArticle,
  baseUrl,
  associationWords,
  checkUserId
}
